// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer___2eEzd","a":"a___33di8","tel":"tel___1LJAg"};


//////////////////
// WEBPACK FOOTER
// ./app/js/components/Footer/style.scss
// module id = 116
// module chunks = 0